import { Box, styled } from '@mui/material';

export const MainContainer = styled(Box)({
  borderRadius: 10,
  backgroundColor: '#F5F5F5',
  padding: 10,
});
